import { useClearChatsOnRouteChange } from '../../hooks/useClearChatsOnUnmount';
export function ClearChatsHandler() {
  useClearChatsOnRouteChange();
  return null;
}
